module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "star-outline.7de9302b.svg";